var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('iframe',{staticClass:"w-full min-h-screen",attrs:{"src":"https://portal.productboard.com/qy7vidvq7qvfadxmfbueb7q2","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }